import jQuery from "jquery";
window.$ = jQuery;

$(function () {
    let isDesktopMenu = (e) => "fixed" !== $(e).parents(".menu-toggleable-left").css("position");
    let p = document.getElementById("navigationColorDefault");
    let defaultColor = p ? p.value : "";
    let header = document.getElementsByClassName("header-nav");
    header.length && (header = header[0]);

    //For dropdown
    $('.header-nav .dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on("click", function () {
            //For desktop menu
            if (isDesktopMenu(this)) {
                if ($(this).parent().hasClass("show")) {
                    $(this).parent().removeClass("show");
                    $(this).siblings(".dropdown-menu").removeClass("show");
                    $(this).attr("aria-expanded", "false");
                    /*
                    if ("true" == defaultColor && header.classList.contains("undo-dark")) {
                        header.classList.remove("undo-dark");
                        header.classList.add("dark");
                        let subEl = $(header).find(".undo-btn-alt-on-dark");
                        if (subEl.length) {
                            for (let n = 0; n < subEl.length; n += 1) {
                                $(subEl[n]).addClass("btn-alt-on-dark");
                                $(subEl[n]).removeClass("btn-alt");
                                $(subEl[n]).removeClass("undo-btn-alt-on-dark");
                            }
                        }
                    }
                    */
                } else {
                    $(".navbar-nav > li").each(function () {
                        $(this).removeClass("show");
                        $(this).children(".dropdown-menu").removeClass("show");
                        $(this).children(".nav-link").attr("aria-expanded", "false");
                    });
                    $(this).parent().addClass("show");
                    $(this).siblings(".dropdown-menu").addClass("show");
                    $(this).attr("aria-expanded", "true");
                    $("#userMenu.js-subnav-menu").length > 0 && $("#userMenu.js-subnav-menu").removeClass("open");
                    /*
                    if ("true" == defaultColor && header.classList.contains("dark")) {
                        header.classList.remove("dark");
                        header.classList.add("undo-dark");
                        let r = $(header).find(".btn-alt-on-dark");
                        if (r.length) {
                            for (let a = 0; a < r.length; a += 1) {
                                $(r[a]).addClass("undo-btn-alt-on-dark");
                                $(r[a]).addClass("btn-alt");
                                $(r[a]).removeClass("btn-alt-on-dark");
                            }
                        }
                    }
                        */
                }
            }
        })
        .on("click", function (event) {
            //For mobile menu
            if (!isDesktopMenu(this)) {
                $(".modal-background").show();
                let dropdown_item = $('<li class="dropdown-item top-category pl-md-48 pb-32 pb-sm-48 d-lg-none" role="button"></li>');
                let n = $(this).clone().removeClass("dropdown-toggle").removeAttr("data-toggle").removeAttr("aria-expanded").attr("aria-haspopup", "false");
                dropdown_item.append(n);
                let nav_menu = $('<li class="nav-menu"></li>');
                nav_menu.append($(".close-menu").first().clone());
                $(this).parent().children(".dropdown-menu").prepend(dropdown_item).prepend(nav_menu).attr("aria-hidden", "false");
                $(this).parent().children(".dropdown-menu").children(".menu-sub").children("li:first-child").addClass("show");
                $(this).parent().children(".dropdown-menu").children(".menu-sub").children("li:first-child").children(".nav").removeClass("d-none").slideDown();
                if ($(this).parent().hasClass("show")) {
                    $(this).parent().removeClass("show");
                    $(this).siblings(".nav").slideUp();
                } else {
                    $(this).parent().addClass("show");
                    $(this).siblings(".nav").removeClass("d-none").slideDown();
                    $(this).parent().find(".dropdown-menu").removeClass("d-none");
                }
                $(this).parent().siblings().removeClass("show");
                $(this).parent().siblings().children(".nav").slideUp();
                $(this).attr("aria-expanded", "true");
                $(n).trigger("focus");
                $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
                event.preventDefault();
            }
        })
        .parent()
        .on("click", ".dropdown-item.top-category", function (event) {
            event.preventDefault();

            if (!isDesktopMenu(this)) {
                $(this).closest(".dropdown-menu").find(".back").trigger("click");
            }
            $(".main-menu .nav.navbar-nav .dropdown-menu").addClass("d-none");
        });

    // For close buttons
    $(".navbar>.close-menu .close-button").on("click", function (e) {
        e.preventDefault();
        $(".menu-toggleable-left").removeClass("in");
        $(".main-menu .nav.navbar-nav .dropdown-menu").removeClass("d-none");
        $(".modal-background").hide();
        $(".navbar-toggler").focus();
        $(".main-menu").attr("aria-hidden", "true");
        $(".main-menu").siblings().attr("aria-hidden", "false");
        $("header").siblings().attr("aria-hidden", "false");
        $("body").removeClass("stop-scroll");
    });
    $(".navbar-nav").on("click", ".close-button", function (e) {
        e.preventDefault();
        $(".navbar-nav").find(".top-category").detach();
        $(".navbar-nav").find(".nav-menu").detach();
        $(".navbar-nav").find(".show").removeClass("show");
        $(".menu-toggleable-left").removeClass("in");
        $(".main-menu").siblings().attr("aria-hidden", "false");
        $("header").siblings().attr("aria-hidden", "false");
        $(".modal-background").hide();
    });
    $(".navbar-nav").on("click", ".back", function (e) {
        let t;
        e.preventDefault();
        t = this;
        $(t).closest(".dropdown").children(".dropdown-menu").children(".top-category").detach();
        $(t).closest(".dropdown.show").children(".nav-link").attr("aria-expanded", "false");
        $(t).closest(".dropdown.show").children(".dropdown-menu").attr("aria-hidden", "true");
        $(t).closest(".dropdown.show").removeClass("show");
        $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "false");
        $(t).closest("li").detach();
    });

    // For closing menu when clicked outside
    $(document).on("click", function (e) {
        if (0 === $(e.target).parents(".navbar").length) {
            if ($(".navbar-nav .nav-item").hasClass("show")) {
                $(".navbar-nav > li").each(function () {
                    $(this).removeClass("show");
                    $(this).children(".dropdown-menu").removeClass("show");
                    $(this).children(".nav-link").attr("aria-expanded", "false");
                    /*if ("true" == defaultColor && header.classList.contains("undo-dark")) {
                        header.classList.remove("undo-dark");
                        header.classList.add("dark");
                        let e = $(header).find(".undo-btn-alt-on-dark");
                        if (e.length) {
                            for (let o = 0; o < e.length; o += 1) {
                                $(e[o]).addClass("btn-alt-on-dark");
                                $(e[o]).removeClass("btn-alt");
                                $(e[o]).removeClass("undo-btn-alt-on-dark");
                            }
                        }
                    }*/
                });
            }
        }
    });

    //For opening collapisble menu
    $(".navbar-toggler").on("click", function (e) {
        e.preventDefault();
        $(".main-menu").toggleClass("in");
        $(".modal-background").show();
        $(".main-menu").removeClass("d-none");
        $(".main-menu").attr("aria-hidden", "false");
        $(".main-menu").siblings().attr("aria-hidden", "true");
        $("header").siblings().attr("aria-hidden", "true");
        $(".main-menu .nav.navbar-nav .nav-link").first().focus();
        $(".main-menu .nav.navbar-nav .dropdown-menu").addClass("d-none");
        $("body").addClass("stop-scroll");
    });

    //On page scroll for menu
    $(window).on("scroll", function () {
        let header_banner_height = $(".header-banner").length && $(".header-banner").height() ? $(".header-banner").height() : "30",
            top_content_area_height = $(".top-content-area").height(),
            dynamic_content = $(".dynamic-content"),
            n = dynamic_content.length ? dynamic_content.offset().top : $(this).scrollTop();
        const scrollTop = $(this).scrollTop();
        const isDarkNav = "true" == defaultColor && "dark" == $(".find-tire-button").data("nav");

        if (scrollTop >= header_banner_height && scrollTop <= n) {
            // When scrolling within the header area
            $(".header-nav").not(".checkout-header-pages").addClass("position-fixed");
            $("header").addClass("header-sticky");

            /*
            if (isDarkNav) {
                $(".find-tire-button").addClass("btn-alt").removeClass("btn-alt-on-dark");
                $(".find-store-button").addClass("btn-alt").removeClass("btn-alt-on-dark");
            }
            */

            if (scrollTop >= top_content_area_height + $("header").height()) {
                // When scrolling past content area
                $(".header-nav").removeClass("position-fixed");
                $("header").removeClass("header-sticky");

                // if (isDarkNav) {
                //     $(".find-tire-button").addClass("btn-alt-on-dark").removeClass("btn-alt");
                //     $(".find-store-button").addClass("btn-alt").removeClass("btn-alt-on-dark");
                // }
            } else {
                // When not past content area but still in header area
                $(".header-nav").not(".checkout-header-pages").addClass("position-fixed");
                $("header").addClass("header-sticky");
            }
        } else {
            // When outside header area
            $(".header-nav").removeClass("position-fixed");
            $("header").removeClass("header-sticky");

            // if (isDarkNav) {
            //     $(".find-tire-button").addClass("btn-alt-on-dark").removeClass("btn-alt");
            //     $(".find-store-button").addClass("btn-alt-on-dark").removeClass("btn-alt");
            // }
        }
    });
});
